'use client'

import type { MediaGalleryFieldsFragment } from '@/graphql/types'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'
import { DynamicMediaGallery } from '@ccpgames/eve-web-core'
import { mapMediaBlocksToItems } from '../utils'
import { useDlpTheme } from '@/components/providers/DlpThemeProvider'
import { toLibraryDlpTheme } from '@/lib/dlp-theme'
import { buildContentfulInspectorProps } from '@/components/providers/contentfulInspectorProps'

interface MediaGalleryQuotesProps {
  entry: MediaGalleryFieldsFragment
}

/**
 * Quotes view: Uses the library DynamicMediaGallery implementation.
 */
export function MediaGalleryQuotes({ entry }: MediaGalleryQuotesProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)
  const pageTheme = useDlpTheme()
  const theme = toLibraryDlpTheme(pageTheme)
  const view = 'quotes' as const

  const items = mapMediaBlocksToItems(updatedEntry.contentCollection, {
    view,
    getItemSectionInspectorProps: (mediaBlock) => buildContentfulInspectorProps(mediaBlock.sys.id, 'media'),
  })

  if (items.length === 0) {
    return null
  }

  return (
    <DynamicMediaGallery
      view={view}
      title={updatedEntry.title ?? undefined}
      content={updatedEntry.subtitle ?? undefined}
      items={items}
      theme={theme}
      sectionInspectorProps={inspectorProps('contentCollection')}
    />
  )
}
